import WordsFetch from './WordsFetch'
export { default as documentsFetcher } from './DocumentsFetch'
export { default as masterDataFetcher } from './MasterDataFetch'
export { default as redactionsFetcher } from './RedactionsFetch'
export { default as tasksFetcher } from './TasksFetch'

const wordsFetcher = new WordsFetch();
export { wordsFetcher };